export default __webpack_public_path__ + "static/media/down.8cb8813f.svg";